import { Component, input } from '@angular/core';
import { Car } from '../../models/car-model';

@Component({
  selector: 'car-list',
  standalone: false,
  templateUrl: './car-list.component.html',
  styleUrl: './car-list.component.scss',
})
export class CarListComponent {
  cars = input<Car[]>();
  listId = input<string>('carList');
}
